let bundleAdd = document.querySelector('[data-bundle]');

if(bundleAdd) {
bundleAdd.addEventListener("click", (e) => {
    let product1 = e.target.getAttribute('data-product');
    let product2 = e.target.getAttribute('data-bundle');
    let discount = e.target.getAttribute('data-discount');
    e.target.querySelector('.add-text').classList.add('opacity-0');
    e.target.querySelector('.loading__spinner').classList.remove('hidden');
    addBundle(product1, product2, discount);
});
}

function getKitEguideData() {
    const scriptTag = document.getElementById('kit-eguide-data');
    if (!scriptTag) return null;
    try {
        return JSON.parse(scriptTag.textContent);
    } catch (error) {
        return null;
    }
}

function buildEguideProperties(eguideData) {
    if (!eguideData || !eguideData.headline) return {};
    const props = {
        '_eguide_headline': eguideData.headline,
        '_eguide_copy': eguideData.copy || '',
        '_eguide_url': eguideData.url || ''
    };
    if (eguideData.image) {
        props['_eguide_image'] = eguideData.image;
    }
    return props;
}

function addBundle(product1, product2, discount) {
    const eguideData = getKitEguideData();

    const productProps = eguideData ? buildEguideProperties(eguideData.product) : {};
    const bundleProps = eguideData ? buildEguideProperties(eguideData.bundle) : {};

    const item1 = { id: product1, quantity: 1 };
    const item2 = { id: product2, quantity: 1 };

    if (Object.keys(productProps).length > 0) {
        item1.properties = productProps;
    }

    if (Object.keys(bundleProps).length > 0) {
        item2.properties = bundleProps;
    }

    let formData = { items: [item1, item2] };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(response => {
            return response.json();
        })
        .then(response => {
            if (discount) {
                window.location.href = `/discount/${discount}?redirect=/checkout`;
            }
            else {
                window.location.href = "/checkout";
            }
        })
        .catch((error) => {
            console.error('Error:', error);
        });
}
